export default {
  'notification.page.title': 'System Notification Management',
  'notification.page.subtitle': 'Send in-app notifications to targeted user groups',
  'notification.alert.title': 'Precise Targeting',
  'notification.alert.description': 'Use the filters below to precisely target groups of users based on their activity and account status.',
  'notification.card.target.title': 'Target Audience',
  'notification.card.target.matching': 'Matching Wallets:',
  'notification.form.specificWallet.label': 'Wallet Address List (Optional)',
  'notification.form.specificWallet.placeholder': 'Enter one or more wallet addresses (separated by comma, space or newline)...',
  'notification.form.criteria.divider': 'Filtering Criteria',
  'notification.form.level.label': 'User Level',
  'notification.form.level.all': 'All Levels',
  'notification.form.level.L1': 'Level 1',
  'notification.form.level.L2': 'Level 2',
  'notification.form.xStatus.label': 'X (Twitter) Status',
  'notification.form.tgStatus.label': 'Telegram Status',
  'notification.form.gmailStatus.label': 'Gmail Status',
  'notification.form.status.all': 'All',
  'notification.form.status.linked': 'Linked',
  'notification.form.status.unlinked': 'Not Linked',
  'notification.card.content.title': 'Message Content',
  'notification.form.contentEn.label': 'English Content',
  'notification.form.contentVi.label': 'Vietnamese Content',
  'notification.form.content.placeholder': 'Write your announcement or system update here...',
  'notification.form.content.required': 'Please enter notification content',
  'notification.form.content.extra': 'This message will be displayed in the user\'s notification bell based on their language.',
  'notification.button.send': 'Send Notification',
  'notification.confirm.title': 'Confirm Send?',
  'notification.confirm.content': 'Are you sure you want to send this notification to {count} users? This action cannot be undone.',
  'notification.success.sent': 'Successfully sent to {count} users.',
};
